import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from '../../../services/account.service';
import { SCAMP_API } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Irregularidade } from '../../domain/domain.model';


@Injectable({ providedIn: 'root' })
export class IrregularidadeService {

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) { }

    create(data: any)  {
        return this.http.post(`${SCAMP_API.accountApiV1}/irregularidade`, data, {headers : this.account.composeHeaders()});
    }

    read(id: number): Observable<any> {
        return this.http.get<any>(`${SCAMP_API.accountApiV1}/irregularidade/${id}`, {headers : this.account.composeHeaders()});
    }


    update(id: number, data: any) {
        return this.http.put(`${SCAMP_API.accountApiV1}/irregularidade/${id}`, data, {headers : this.account.composeHeaders()});
    }

    delete(id: number) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/irregularidade/${id}`, {headers : this.account.composeHeaders()});
    }


    getAll(): Observable<Irregularidade[]> {
        return this.http.get<Irregularidade[]>(`${SCAMP_API.accountApiV1}/irregularidades`, {headers : this.account.composeHeaders()});
    }

    search(parametro: string, tipo: number): Observable<any[]> {
        return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/irregularidade-search/${parametro}/${tipo}`,
        {headers : this.account.composeHeaders()});
    }


    isUniqueDescricaoIrregularidade(descricao: string, id: number): Observable<boolean> {
        return this.http.post<boolean>(`${SCAMP_API.accountApiV1}/descricao-irregularidade-is-unique`, {descricao, id},
        {headers : this.account.composeHeaders()});
    }

    isUniqueDescricaoAbreviadaIrregularidade(descricaoAbreviada: string, id: number): Observable<boolean> {
        return this.http.post<boolean>(`${SCAMP_API.accountApiV1}/descricao-abreviada-irregularidade-is-unique`, {descricao: descricaoAbreviada, id},
        {headers : this.account.composeHeaders()});
    }

    

}
